import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ChevronRight } from 'lucide-react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import Button from '../components/ui/Button';
import { useTheme } from '../contexts/ThemeContext';
import categories from '../data/categories';

/**
 * Компонент NotFoundPage - страница 404 (не найдено)
 */
const NotFoundPage = () => {
  const { darkMode, toggleDarkMode } = useTheme();
  
  // Получаем популярные категории для показа
  const popularCategories = categories.slice(0, 4);
  
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-200">
      {/* Фоновый узор */}
      <div className="fixed inset-0 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] dark:bg-[radial-gradient(#1f2937_1px,transparent_1px)] [background-size:20px_20px] opacity-25 pointer-events-none"></div>
      
      {/* Навигационная панель */}
      <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      
      {/* Основное содержимое */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="text-center">
          <h1 className="text-9xl font-bold text-indigo-600 dark:text-indigo-400">404</h1>
          
          <h2 className="mt-6 text-3xl font-bold text-gray-900 dark:text-white sm:text-4xl">
            Страница не найдена
          </h2>
          
          <p className="mt-4 text-base text-gray-600 dark:text-gray-400 max-w-md mx-auto">
            Упс! Похоже, что страница, которую вы ищете, не существует или была перемещена.
          </p>
          
          <div className="mt-10">
            <Link to="/">
              <Button 
                primary 
                className="inline-flex items-center"
                icon={<Home className="h-5 w-5" />}
              >
                Вернуться на главную
              </Button>
            </Link>
          </div>
        </div>
        
        {/* Рекомендуемые категории */}
        <div className="mt-16">
          <h3 className="text-center text-lg font-medium text-gray-900 dark:text-white mb-6">
            Возможно, вас заинтересуют эти категории:
          </h3>
          
          <div className="flex flex-wrap justify-center gap-4">
            {popularCategories.map(category => (
              <Link 
                key={category.id}
                to={`/category/${category.slug}`}
                className="inline-flex items-center px-4 py-2 rounded-lg bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
              >
                {category.name}
                <ChevronRight className="ml-1 h-4 w-4" />
              </Link>
            ))}
          </div>
        </div>
      </main>
      
      {/* Футер */}
      <Footer />
    </div>
  );
};

export default NotFoundPage;